import { render, staticRenderFns } from "./EditNews.vue?vue&type=template&id=41666266&scoped=true&lang=pug"
import script from "./EditNews.vue?vue&type=script&lang=js"
export * from "./EditNews.vue?vue&type=script&lang=js"
import style0 from "./EditNews.vue?vue&type=style&index=0&id=41666266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41666266",
  null
  
)

export default component.exports